import { render, staticRenderFns } from "./NavTabs.vue?vue&type=template&id=8bcff02c&scoped=true"
import script from "./NavTabs.vue?vue&type=script&lang=js"
export * from "./NavTabs.vue?vue&type=script&lang=js"
import style0 from "./NavTabs.vue?vue&type=style&index=0&id=8bcff02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcff02c",
  null
  
)

export default component.exports